import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MdIconRegistry } from '@angular/material';

import { AuthenticationService } from './services';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  
})
export class AppComponent {
  
    token: any;
    
     constructor(private _iconRegistry: MdIconRegistry,
                private authenticationService: AuthenticationService,
              private _domSanitizer: DomSanitizer) {
                  console.clear();
    //this._iconRegistry.addSvgIconInNamespace('assets', 'teradata',
    //  this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/teradata.svg'));
    //this._iconRegistry.addSvgIconInNamespace('assets', 'github',
    //  this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/github.svg'));
    this._iconRegistry.addSvgIconInNamespace('assets', 'mcg',
      this._domSanitizer.bypassSecurityTrustResourceUrl('assets/logo.png'));
    //this._iconRegistry.addSvgIconInNamespace('assets', 'covalent-mark',
    //  this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/covalent-mark.svg'));
    //this._iconRegistry.addSvgIconInNamespace('assets', 'teradata-ux',
    //  this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/teradata-ux.svg'));
    //this._iconRegistry.addSvgIconInNamespace('assets', 'appcenter',
    //  this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/appcenter.svg'));
    //this._iconRegistry.addSvgIconInNamespace('assets', 'listener',
    //  this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/listener.svg'));
    //this._iconRegistry.addSvgIconInNamespace('assets', 'querygrid',
    //  this._domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/querygrid.svg'));
  }
    
    ngOnInit() {
        this.authenticationService.getUserName().subscribe(message => { this.token = message; });
    }
        
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/app.component.ts